//常用状态管理
export const commonCodes = {
	auction:{
        //是否
        orCodes:[{value:'0',label:'否'},{value:'1',label:'是'}],
        //参与方式
        appointCodes:[{value:'0',label:'不定向'},{value:'1',label:'定向'}],
        //交货方式
        deliveryCodes:[{value:'0',label:'卖家送货'},{value:'1',label:'买家自提'}],
        //锁定方式
        lockWayCodes:[{value:'0',label:'按次锁定'},{value:'1',label:'按数量锁定'}],
        //场次状态
        statusCodes:[
            {value:'0',label:'已作废'},
            {value:'1',label:'已终止'},
            {value:'8',label:'已拒绝'},
            {value:'9',label:'已撤销'},
            {value:'10',label:'已生成'},
            {value:'20',label:'待审核'},
            {value:'30',label:'已审核'},
            {value:'31',label:'待竞拍'},
            {value:'35',label:'申请终止'},
            {value:'40',label:'竞价中'},
            {value:'50',label:'已结束'},
            {value:'60',label:'已评标'},
            {value:'61',label:'已流标'}
        ],
        //报盘方式
        offerTypCodes:[{value:'0',label:'单价'},{value:'1',label:'总价'}],
        //竞价模式
        trayTypCodes:[{value:'0',label:'公开增价'},{value:'1',label:'自由报价'}],
        //竞拍规则
        trayRuleCodes:[{value:'0',label:'价高者得'},{value:'1',label:'手工评标'}],
        //竞拍结果
        fruitCodes:[{value:'50',label:'已结束'},{value:'60',label:'已参加'},{value:'61',label:'已流标'}],
        //资源属性
        resourceCodes:[{value:'0',label:'现货库存'},{value:'1',label:'产能预售'}],
        //采购方式
        purchaseTypeCodes: [
            { value: '1', label: '长协采购' },
            { value: '2', label: '单次采购' }
        ]
    },
    trade:{
        //是否
        orCodes:[{value:'0',label:'否'},{value:'1',label:'是'}],
        //是否议价
        orYjCodes:[{value:'0',label:'不议价'},{value:'1',label:'可议价'}],
        //操作类型
        czTypeCodes:[{value:'1',label:'批量加价'},{value:'2',label:'批量减价'},{value:'3',label:'统一价'}],
        //合同状态
        htStatusCodes:[
            {value:'0',label:'作废'},
            {value:'10',label:'待卖方编辑合同'},
            {value:'20',label:'待卖方确认合同'},
            {value:'30',label:'待买方确认合同'},
            {value:'40',label:'待买方支付货款'},
            {value:'50',label:'提货中（待卖方生成提单）'},
            {value:'60',label:'提货中（已生成提单）'},
            {value:'70',label:'已生成提单'},
            {value:'80',label:'待买方到货确认'},
            {value:'90',label:'验货确认'}
        ],
        //供应商申请状态
        applyCodes:[{value:'0',label:'待审核'},{value:'1',label:'审核通过'},{value:'2',label:'审核不通过'}],
        //会员组类型
        hyCodes:[{value:'1',label:'挂牌定向'},{value:'2',label:'竞价定向'}],
        //提单状态
        tdCodes:[
            {value:'70',label:'待实提维护'},
            {value:'80',label:'待买方到货确认'},
            {value:'90',label:'已验货确认待结算'}
        ],
        //发票状态
        fpCodes:[{value:'1',label:'已开票未验票'},{value:'2',label:'已验票'}],
    },
    rep:{
        //是否
        orCodes:[{value:'0',label:'否'},{value:'1',label:'是'}],
        //是否议价
        orYjCodes:[{value:'0',label:'不议价'},{value:'1',label:'可议价'}],
        //洽谈状态
        qtCodes:[{value:'0',label:'未洽谈'},{value:'1',label:'待卖方响应'},{value:'2',label:'待买方响应'},{value:'3',label:'同意报价'},{value:'4',label:'拒绝报价'}],
    },
    listed:{
        //洽谈状态
        qtCodes:[{value:'0',label:'未洽谈'},{value:'1',label:'待卖方响应'},{value:'2',label:'待买方响应'},{value:'3',label:'同意报价'},{value:'4',label:'拒绝报价'}],
    }
}

//搜索条件类型管理
export const commonSearch = {
    system:{
        //变更类型(0:银行变更,1：资质变更,2：发票变更)
		optType:{type0:0,type1:1,type2:2},
    }
}

//文件类型管理
export const commonUpload = {
    system:{
		/**菜单目录 */
		//子系统图标
		SYS_TYPE3:"SYS003",
	},
}

//文件上传类型
export const upFileTypes = {
	img:'image/png,image/jpg,image/jpeg',
	file:'.docx,.pdf,.ppt,.xls,.xlsx,.pptx,.doc',
	allfile:'image/png,image/jpg,image/jpeg,.docx,.pdf,.ppt,.xls,.xlsx,.pptx,.doc'
}





// WEBPACK FOOTER //
// ./src/server/common-codes.js